<template>
    <section class="beneficial">

        <div class="load load-200" v-if="!showContent"></div>

        <div class="container" v-if="showContent && errorsGet.dataCompliance != false">
            <div class="box-error">
                <h3 class="title-secondary">
                    {{ getMyLanguage("box-error", "title-error") }}
                </h3>

                <p>{{ getMyLanguage("box-error","msg-error") }}</p>
            </div>
        </div>

        <div class="container" v-if="showContent && !errorsGet.dataCompliance">
            
            <div class="box-beneficial">
                <h2 class="title-secondary">Declaration of identity of the beneficial owner</h2>
                
                <!-- FORM BENEFICIAL -->
                <div>
                    <div class="box-registration">
                        <div class="formBox">
                            <div class="partner">
                                <div>
                                    <h3 class="subtitle">Contracting partner:</h3>
                                    <p>DNE International Sagl</p>
                                    <p>CHE-409.547.100 / Switzerland</p>
                                </div>
                            </div>
                            <p>In accordance with Article 4 of the Anti-Money Laundering Act, the contracting partner hereby declares that the person(s) listed below is / are the beneficial owner(s) of the assets deposited under the above relationship. If the contracting partner is the beneficial owner of the assets, the contracting partner’s details must be set out below:</p>
                        </div>
                    </div>

                    <div class="box-registration">
                        <div class="formBox">
                            <div class="row">
                                <div class="col-12">
                                    <label class="formName">
                                        <span>Complete name / entity:</span>
                                        <div class="form form-disabled"><span>{{dataCompliance.full_name}}</span></div>
                                    </label>
                                </div>

                                <div class="col-12 col-lg-6">
                                    <label class="formPersonDOB">
                                        <span>Date of birth:</span>
                                        <div class="form form-disabled"><span>{{dateTime(dataCompliance.dob)}}</span></div>
                                    </label>
                                </div>

                                <div class="col-12 col-lg-6">
                                    <div class="autocomplete formIssuerCountry">
                                        <label>
                                            <span>Nationality:</span>
                                            <div class="form form-disabled"><span>{{ dataCountry.filter(country => country.Id == dataCompliance.country_id)[0].Name }}</span></div>
                                        </label>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <label class="formAddress last">
                                        <span>Actual address of domicile / registered office (incl. country):</span>
                                        <div class="form form-disabled"><span>{{dataCompliance.full_address}}</span></div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="box-registration">
                        <div class="formBox">
                            <h3 class="subtitle">The contracting partner hereby undertakes to automatically inform the bank of any changes.</h3>

                            <div class="date-signature">
                                <label>
                                    <span>Date:</span>
                                    <div class="form form-disabled"><span>{{dateTimeFull(dataCompliance.sign_date)}}</span></div>
                                </label>

                                <label>
                                    <span>Signature(s):</span>
                                    
                                    <div class="digital-signature">
                                        <img :src="`data:image/svg+xml;base64,${dataCompliance.signature}`">
                                    </div>

                                    <span class="form formSignature" v-html="dataCompliance.full_name"></span>
                                </label>
                            </div>
                            
                            <p class="alert">
                                It is a criminal offence to deliberately provide false information on this form (Article 251 of the Swiss Criminal Code, document forgery).
                            </p>
                        </div>
                    </div>
                </div>

                <div class="bt-registration">
                    <div @click="generateReport()" class="download-pdf">PDF</div>
                </div>


                <!-- PRINT PDF -->
                <vue3-simple-html2pdf
                    ref="vue3SimpleHtml2pdf"
                    :options="pdfOptions"
                    :filename="exportFilename"
                    >

                    <div class="print" id="printArea">

                        <h2 class="title-secondary">Declaration of identity of the beneficial owner</h2>

                        <div class="table">
                            <tr>
                                <td colspan="2">
                                    <h3 class="subtitle">Contracting partner:</h3>
                                    <p>DNE International Sagl</p>
                                    <p>CHE-409.547.100 / Switzerland</p>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2"></td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <p>In accordance with Article 4 of the Anti-Money Laundering Act, the contracting partner hereby declares that the person(s) listed below is / are the beneficial owner(s) of the assets deposited under the above relationship. If the contracting partner is the beneficial owner of the assets, the contracting partner’s details must be set out below:</p>
                                </td>
                            </tr>
                            <p>&nbsp;</p>
                            <tr>
                                <td colspan="2">
                                    <div class="form-print">
                                        <span>Complete name / entity:</span>
                                        <div class="form form-disabled">{{dataCompliance.full_name}}</div>

                                        <span>Date of birth:</span>
                                        <div class="form form-disabled">{{dateTime(dataCompliance.dob)}}</div>

                                        <span>Nationality:</span>
                                        <div class="form form-disabled">{{ dataCountry.filter(country => country.Id == dataCompliance.country_id)[0].Name }}</div>

                                        <span>Actual address of domicile / registered office (incl. country):</span>
                                        <div class="form form-disabled full">{{dataCompliance.full_address}}</div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <p>&nbsp;</p>
                                    <h3 class="subtitle">The contracting partner hereby undertakes to automatically inform the bank of any changes.</h3>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div class="date-signature-print">
                                        <span>Date:</span>
                                        <div class="form form-disabled">{{dateTimeFull(dataCompliance.sign_date)}}</div>
                                    </div>
                                </td>
                                
                                <td>
                                    <div class="digital-signature-print">
                                        <div>
                                            <span>Signature(s):</span>

                                            <div class="digital-signature">
                                                <img :src="`data:image/svg+xml;base64,${dataCompliance.signature}`">
                                            </div>

                                            <span class="form formSignature" v-html="dataCompliance.full_name"></span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <p class="alert">
                                        It is a criminal offence to deliberately provide false information on this form (Article 251 of the Swiss Criminal Code, document forgery).
                                    </p>
                                </td>
                            </tr>
                        </div>
                    </div>
                </vue3-simple-html2pdf>
            </div>
        </div>
    </section>
</template>


<script>
    import apiBackoffice from '@/config/apiBackoffice.js'
    import moment from 'moment';

    const html2pdf = require('html2pdf.js')

    export default {
        props: {
            index: {
                type: Number,
                default: 1,
            },
            filename: {
                type: String,
                default: '',
            },
            options:{
                default: {
                    margin: 15,
                    image: {
                        type: 'jpeg',
                        quality: 1,
                    },
                    html2canvas: { scale: 3 },
                }
            }
        },

        data(){
            return{
                showContent: false,
                flagSelected: "pt",

                dataCompliance: {
                    full_name: "Julio Ricardo Petters Siqueira",
                    dob: "1981-08-25T00:00:00Z",
                    country_id: "acc8b9e4-d63b-442f-b2d3-ed5593e6459f",
                    full_address: "Alameda da República, 123, ap 321, Vila Nova de Gaia",
                    sign_date: "2023-04-28T16:29:19.354687Z",
                    signature: "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"
                },

                dataCountry: [],

                errorsGet: {
                    dataCompliance: false
                }
            }
        },

        async mounted(){
            await apiBackoffice.get(`/api/v2/platform/compliance/ubo/person/${this.$route.params.accountId}`)
            .then(response => {
                this.dataCompliance = response.data
                this.dataCompliance.signature = "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"
                console.log(this.dataCompliance)

                this.signatureName()
            })
            .catch(error => {
                console.log(error)
                this.errorsGet.dataCompliance = true
            })
        },

        methods: {
            dateTime(value) {
                // const format = this.flagSelected === 'en' ? 'YY/MM/DD' : 'DD/MM/YY';
                const format = 'DD/MM/YYYY';
                return moment(value).format(format);
            },

            dateTimeFull(value) {
                const format = 'll'
                return moment.utc(value).locale(format).format('ll');
            },

            signatureName(){
                const nameSignature = this.dataCompliance.full_name;
                const nameSignatureLowercase = nameSignature.toLowerCase();
                const words = nameSignatureLowercase.split(' ');
                const wordsUppercase = words.map(words => words.charAt(0).toUpperCase() + words.slice(1));
                const nameSignatureFinished = wordsUppercase.join(' ');
                this.dataCompliance.full_name = nameSignatureFinished;
            },

            generateReport () {
                document.getElementById("printArea").style.display = "block"

                setTimeout(() => {
                    document.getElementById("printArea").style.display = "none"
                }, 50);
                
                const el = document.getElementById(`Vue3SimpleHtml2pdf${this.index}`)
                if (!el) {
                    return
                }
                html2pdf().from(el).set(this.options).save("Compliance - " + this.dataCompliance.full_name)
            }
        },

        watch: {
            '$store.state.allCountries': {
                immediate: true,
                handler() {
                    this.dataCountry = this.$store.state.allCountries

                    setTimeout(() => {
                        this.showContent = true
                    }, 1500);
                }
            }
        }
    }
</script>

<style src="./custom-ubo.scss" lang="scss" scoped />